'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function queryAll(root, selector) {
  return Array.from(root?.querySelectorAll(selector) ?? []);
}
function query(root, selector) {
  return root?.querySelector(selector);
}

exports.query = query;
exports.queryAll = queryAll;
